// LoginScreen — "Playful Frost" auth, a faithful port of the design LoginScreen:
// a single frosted-glass card with the mascot peeking over the top, a logo +
// tagline, a frosted credential-entry panel, a block primary CTA, an "or"
// divider, and the rights line below. Prefix: rah-. Over the scattered
// school-icon login pattern (bg-catchup-pattern-login).
export const loginScreenStyles = `
.rah-root {
  position: relative;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 96px var(--space-4) var(--space-6);
  background-color: var(--catchup-blue-50);
  background-size: 460px;
  z-index: 0;
}
.rah-root::before {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 0;
  background:
    radial-gradient(circle at 50% 30%, rgba(87, 194, 211, 0.18), transparent 60%),
    linear-gradient(180deg, rgba(245, 254, 255, 0.4), rgba(202, 248, 255, 0.55));
}
.rah-wrap {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.rah-mascot {
  position: absolute;
  bottom: calc(100% - 56px);
  left: 50%;
  transform: translateX(-54%);
  width: auto;
  height: 152px;
  z-index: 0;
  filter: drop-shadow(0 14px 20px rgba(15, 72, 89, 0.22));
  pointer-events: none;
}
.rah-card {
  position: relative;
  width: 100%;
  overflow: hidden;
  z-index: 1;
  background-color: var(--glass-flat-bg);
  -webkit-backdrop-filter: var(--glass-flat-filter);
  backdrop-filter: var(--glass-flat-filter);
  border: 1px solid var(--glass-border, var(--glass-flat-border));
  border-radius: var(--rad-catchup-2xlarge);
  box-shadow: var(--glass-flat-edge), var(--glass-float, 0 24px 60px -24px rgba(15, 72, 89, 0.4));
}
.rah-card::before {
  content: "";
  position: absolute;
  inset: 0 0 auto 0;
  height: 45%;
  background: var(--sheen-soft);
  pointer-events: none;
  z-index: 0;
}
.rah-inner {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-8) var(--space-5) var(--space-5);
}
.rah-logo {
  height: 32px;
  margin-top: var(--space-2);
  object-fit: contain;
}
.rah-tag {
  font-size: var(--fs-base);
  color: var(--text-muted);
  font-weight: 500;
  margin-bottom: var(--space-3);
  text-align: center;
}
.rah-form {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  width: 100%;
}
/* Frosted-glass panel around the credential-entry fields */
.rah-fields {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  padding: var(--space-5) var(--space-4) var(--space-4);
  border-radius: var(--rad-catchup-large);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.85), rgba(240, 253, 255, 0.72));
  -webkit-backdrop-filter: blur(20px) saturate(1.7);
  backdrop-filter: blur(20px) saturate(1.7);
  border: 1px solid var(--color-info-border, var(--glass-flat-border));
  box-shadow:
    var(--glass-flat-edge),
    inset 0 1px 1px rgba(255, 255, 255, 0.7),
    0 12px 30px -12px rgba(15, 72, 89, 0.28);
}
.rah-row {
  display: flex;
  justify-content: flex-end;
  margin-top: -4px;
}
.rah-link {
  cursor: pointer;
  color: var(--catchup-blue-600);
  font-size: var(--fs-md);
  font-weight: var(--font-weight-semi);
}
.rah-link:hover {
  color: var(--catchup-blue-700);
  text-decoration: underline;
}
.rah-divider {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  color: var(--text-muted);
  font-size: var(--fs-md);
}
.rah-divider::before,
.rah-divider::after {
  content: "";
  flex: 1;
  height: 1px;
  background: var(--catchup-blue-100);
}
.rah-google {
  display: flex;
  justify-content: center;
}
.rah-admin {
  font-size: var(--fs-md);
  color: var(--text-secondary);
  margin-top: var(--space-4);
  text-align: center;
}
.rah-rights {
  position: relative;
  margin-top: var(--space-8);
  font-size: var(--fs-md);
  color: var(--text-muted);
}
`;
